import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

import { useLandingPage } from './useLandingPage';
import { TemplateProps } from './types';
import Classico from './templates/Classico';
import Moderno from './templates/Moderno';

const TEMPLATES: Record<string, React.ComponentType<TemplateProps>> = {
  classico: Classico as React.ComponentType<TemplateProps>,
  moderno: Moderno,
};

function LandingPage() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const {
    carteira,
    contatos,
    telValue,
    mensagem,
    callbackAberto,
    recaptchaRef,
    onSelectContato,
    onChangeTel,
    onSubmitTel,
    onFecharCallback,
  } = useLandingPage(params?.id);

  const override =
    process.env.NODE_ENV === 'development' ? searchParams.get('template') : null;

  const Template = TEMPLATES[override ?? carteira?.template ?? ''] ?? Classico;

  return (
    <>
      {carteira && (
        <Template
          carteira={carteira}
          contatos={contatos}
          telValue={telValue}
          mensagem={mensagem}
          callbackAberto={callbackAberto}
          onSelectContato={onSelectContato}
          onChangeTel={onChangeTel}
          onSubmitTel={onSubmitTel}
          onFecharCallback={onFecharCallback}
        />
      )}

      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        hl="pt-BR"
        sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY as string}
      />
    </>
  );
}

export default LandingPage;
